<template>
  <div class="box help-section">
    <div class="box-header">
      <h2 class="box-title" :style="titleCustomStyle">
        {{ helpSectionHeader }}
      </h2>
    </div>
    <div class="box-body">
      <v-list v-if="helpSectionJson || helpSectionText" class="help-list">

        <div v-if="helpSectionJson">
          <div v-html="header"></div>

          <template v-for="(item, index) in lines">
            <v-list-item :key="item.id">
              <v-list-item-content>
                <v-list-item-title>{{ item.points }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-title>{{ item.description }}</v-list-item-title>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < lines.length" :key="index"></v-divider>
          </template>

          <div v-html="footer" class="footer"></div>
        </div>
        <div v-else>
          <div v-html="helpSectionText"></div>
        </div>
      </v-list>
    </div>
  </div>

</template>

<script>
  import _ from 'lodash';

  export default {
    name: "HelpSection",
    props: {
    data: {
      type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        loading: false
      }
    },
    computed: {
      helpSectionHeader() {
        let header = _.get(this.$store.getters.extensionSettings, 'application.loyalty_help_section_header');
        return header || this.$t('helpSection.description')
      },
      helpSectionJson() {
        return _.get(this.$store.getters.extensionSettings, 'loyalty.help_section_json');
      },
      header() {
        return _.get(this.helpSectionJson, 'header');
      },
      lines() {
        return _.get(this.helpSectionJson, 'lines');
      },
      footer() {
        return _.get(this.helpSectionJson, 'footer');
      },
      helpSectionText() {
        return _.get(this.$store.getters.extensionSettings, 'application.loyalty_help_section_text');
      },
      titleCustomStyle() {
        return _.get(this.data, 'style.title', null)
      },
    },
    mounted() {},
    methods: {}
  }
</script>

<style scoped>
  .help-section {
    margin-top: 80px;
    box-shadow: none !important;
  }
  .footer {
    margin-top: 24px;
    font-weight: 700;
  }
</style>
